import SearchOverviewPage from "lx/searchOverviewPage";

export { SearchOverviewPage };

customElements.define(
  "lx-search-overview-page",
  SearchOverviewPage.CustomElementConstructor
);
